// extracted by mini-css-extract-plugin
export var breadcrumbs = "styles-module--breadcrumbs--Rz3Gw";
export var toLeft = "styles-module--toLeft--3lDb9";